<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<p class="tocitem2">C<span class="small">ONTENTS</span></p>
<p class="bigspace">
</p><p class="tocitem"><a href="#/html/08_preface">G<span class="small">ENERAL</span> E<span class="small">DITOR</span>’<span class="small">S</span> P<span class="small">REFACE</span></a></p>
<p class="xsmallspace">
</p><p class="tocitem"><a href="#/html/09_foreword">F<span class="small">OREWORD</span></a></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/10_introduction" title="Link target outside of Sample">I<span class="small">NTRODUCTION</span></span></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/11_explanation" title="Link target outside of Sample">E<span class="small">XPLANATION OF</span> H<span class="small">OW THE</span> O<span class="small">LD</span> T<span class="small">ESTAMENT DESIGNATION</span> “Y<span class="small">A</span>’<span class="small">AKOV</span>” <span class="small">BECAME THE</span> N<span class="small">EW</span> T<span class="small">ESTAMENT DESIGNATION</span>, “I<span class="small">AKOBOY</span>”</span></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/12_chap1" title="Link target outside of Sample">C<span class="small">HAPTER</span> O<span class="small">NE</span></span></p>
<p class="tocitem1"><span href="#/html/12_chap1" title="Link target outside of Sample">The Background of The Book: Yalqut, Greek And “The Principal Matter”</span></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/13_chap2" title="Link target outside of Sample">C<span class="small">HAPTER</span> T<span class="small">WO</span></span></p>
<p class="tocitem1"><span href="#/html/13_chap2" title="Link target outside of Sample">Parashat Kedoshim And Ya’akov</span></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/14_chap3" title="Link target outside of Sample">C<span class="small">HAPTER</span> T<span class="small">HREE</span></span></p>
<p class="tocitem1"><span href="#/html/14_chap3" title="Link target outside of Sample">Who Was Ya’akov? The Man And His Influence</span></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/15_chap4" title="Link target outside of Sample">C<span class="small">HAPTER</span> F<span class="small">OUR</span></span></p>
<p class="tocitem1"><span href="#/html/15_chap4" title="Link target outside of Sample">The Torah Based Concepts Behind The Greek Vocabulary of Yalqut Ya’akov</span></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/16_chap5" title="Link target outside of Sample">C<span class="small">HAPTER</span> F<span class="small">IVE</span></span></p>
<p class="tocitem1"><span href="#/html/16_chap5" title="Link target outside of Sample">The Concept of “Faith And Works”</span></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/17_endnotes" title="Link target outside of Sample">E<span class="small">NDNOTES</span></span></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/18_glossary" title="Link target outside of Sample">GLOSSARY</span></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/19_bibliography" title="Link target outside of Sample">B<span class="small">IBLIOGRAPHY</span></span></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/20_author_biography" title="Link target outside of Sample">A<span class="small">UTHOR</span> B<span class="small">IOGRAPHY</span></span></p>
<p class="xsmallspace">
</p><p class="tocitem"><span href="#/html/21_contributing_author_biography" title="Link target outside of Sample">C<span class="small">ONTRIBUTING</span> A<span class="small">UTHOR</span> B<span class="small">IOGRAPHY</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_contents.vue?53ac178e